import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks';
import { MainLayout } from '@/components/MainLayout/MainLayout';
import { AUTH_STATE } from '@/types';
import { AdminProductContextRedirect } from '@/routing/AdminProductContextRedirect';
import { ROUTE_ALIASES } from '@/routing/routesAliases';
import { LoadingPage } from '@/pages/LoadingPage/LoadingPage';
import { Login } from '@/pages/Login';

export const ProtectedRoute = () => {
  const { state } = useAuth();
  const location = useLocation();

  if (state === AUTH_STATE.LOADING) {
    return <LoadingPage />;
  }

  if (state === AUTH_STATE.UNAUTHENTICATED) {
    if (location.pathname === ROUTE_ALIASES.HOME) {
      return <Login />;
    }

    return <Navigate to={ROUTE_ALIASES.LOGIN} replace state={{ from: location }} />;
  }

  return (
    <>
      <AdminProductContextRedirect />
      <MainLayout />
    </>
  );
};
